import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { AnimalsTableService } from 'src/app/modules/acbcr/common/services/animals-table.service';

@Component({
  selector: 'app-solicitare-test-adn',
  templateUrl: './solicitare-test-adn.component.html',
})
export class SolicitareTestAdnComponent {
  @ViewChild('solicitareTestADN') solicitareTestADN: ElementRef;
  @Input() modalData: any;

  modalReference: NgbModalRef;
  solicitareTestADNForm = new UntypedFormGroup({});
  isAdmin = false;
  isOperator = false;
  animal: any = {};
  tata: any = {};
  mama: any = {};

  constructor(
    public modalService: NgbModal,
    private helperDataService: HelperDataService,
    private animalsTableService: AnimalsTableService,
  ) { }

  ngOnInit() {
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.buildForm();
  }

  ngOnChanges(changes) {
    if (changes.modalData && this.modalData) {
      this.openModal();

      this.animalsTableService.solicitareTestADNAPI(this.modalData)
        .subscribe({
          next: (response) => {
            if (!response) {
              response = {};
            }

            this.animal = response['animal'] || {};
            this.tata = response['tata'] || {};
            this.mama = response['mama'] || {};
            this.buildForm();
          }
        })
    }
  }

  buildForm() {
    let animal_id = this.modalData ? this.modalData['animal_id'] : null;

    this.solicitareTestADNForm = new UntypedFormGroup({
      animal_id: new UntypedFormControl(animal_id),
      animal_material_biologic: new UntypedFormControl(this.animal['material_biologic']),
      tata_material_biologic: new UntypedFormControl(this.tata['material_biologic']),
      mama_material_biologic: new UntypedFormControl(this.mama['material_biologic']),
      teste_adn: new UntypedFormGroup({
        profil: new UntypedFormControl(),
        verificare_mama: new UntypedFormControl(),
        verificare_tata: new UntypedFormControl(),
        verificare_tata_si_mama: new UntypedFormControl(),
        atribuirea_rasei: new UntypedFormControl(),
        test_genomic: new UntypedFormControl(),
        reconstituire_tata: new UntypedFormControl(),
        reconstituire_mama: new UntypedFormControl(),
      }),
    });
  }

  onSubmitted() {
    let fisier = `Solicitare_Test_ADN_${this.solicitareTestADNForm.value.animal_id}.pdf`;

    this.animalsTableService
      .solicitareTestADNDownloadAPI(this.solicitareTestADNForm.value)
      .subscribe({
        next: (response) => {
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);
        }
      })
  }

  openModal() {
    this.modalReference = this.modalService.open(this.solicitareTestADN, {
      windowClass: 'modal-half-full',
      scrollable: true,
    });
  }

}
